export const PROFILE_COMPLETION_PATH = "/app/settings/profile-completion";
export const WORKSPACE_HOME_PATH = "/app/welcomepage";

export const withLocation = (pathname, location) => ({
  pathname,
  search: location?.search || "",
  hash: location?.hash || "",
});

export function routeForStatus(status = "") {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "profilepending") return PROFILE_COMPLETION_PATH;
  if (["suspended", "blocked"].includes(normalized)) return "/no-access";
  return WORKSPACE_HOME_PATH;
}
